export enum BrandTabs {
  BASIC_INFO = 'BASIC_INFO',
  SPONSORS = 'SPONSORS',
  BADGES = 'BADGES',
}
